import { utils, writeFile } from "xlsx";

/**
 * Exports JSON data to a downloadable Excel file
 * @param data - Array of objects to convert to Excel
 * @param filename - File name for downloaded Excel
 * @param sheetName - Name of the Excel sheet
 */
export const exportToExcel = async (
  data: object[],
  filename = "data.xlsx",
  sheetName = "Sheet1"
): Promise<void> => {
  if (!data || data.length === 0) {
    console.warn("No data available to export.");
    return;
  }

  try {
    const worksheet = utils.json_to_sheet(data);

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, sheetName);

    writeFile(workbook, filename);
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }
};
